import { render } from "./packages.vue?vue&type=template&id=26aba428&scoped=true&ts=true"
import script from "./packages.vue?vue&type=script&lang=ts"
export * from "./packages.vue?vue&type=script&lang=ts"

import "./packages.vue?vue&type=style&index=0&id=26aba428&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26aba428"],['__file',"src/views/order/packages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26aba428"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26aba428', __exports__)) {
    console.log('reload')
    api.reload('26aba428', __exports__)
  }
  
  module.hot.accept("./packages.vue?vue&type=template&id=26aba428&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('26aba428', render)
  })

}


export default __exports__